var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"#E6EBEB"}},[_c('div',{staticClass:"opaciter"},[_c('div',{staticClass:"app-container"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }